import React from 'react';
import { useSelector } from 'react-redux';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const CustomBackdrop = styled(Backdrop)(() => ({
  background: 'rgba(255,255,255,0.9)',
  zIndex: '1301',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export default function CacheInitializing() {
  const { error } = useSelector(state => state.cache);

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <CustomBackdrop open>
      {error ? (
        <Box textAlign="center" maxWidth={400}>
          <Alert severity="error" sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              Erreur d'initialisation
            </Typography>
            <Typography variant="body2">
              {error}
            </Typography>
          </Alert>
          <Button
            variant="contained"
            color="primary"
            onClick={handleRetry}
            sx={{ mt: 1 }}
          >
            Réessayer
          </Button>
        </Box>
      ) : (
        <>
          <CircularProgress size={60} color="primary" />
          <Box textAlign="center">
            <Typography variant="h6" color="textPrimary">
              Initialisation en cours...
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              Chargement des données utilisateur
            </Typography>
          </Box>
        </>
      )}
    </CustomBackdrop>
  );
}
